module.exports = "https://coursera_assets.s3.amazonaws.com/images/0dc655b2e1895c9c12365a50498066d0.jpg";